import React from 'react'
import { useParams } from 'react-router'
import { useGetProductByIdQuery } from '../../app/offerApi/OfferApi'
import { Container, Image } from 'react-bootstrap'
import { Row, Col } from 'react-bootstrap'
import CommonBreadcrumb from '../../components/shared/breadcrumb/CommonBreadcrumb'
import Loader from '../../components/shared/loader/Loader'
const ProductView = () => {
    const { id } = useParams()
    const { data: productData, isLoading } = useGetProductByIdQuery(id, { skip: !id })
    console.log(productData, "productData");
    const items = [
        {
            label:"Home",
            path:"/home"
        },
        {
            label:"Product Details"
        }
    ]
     if (isLoading) {
  return (
  <Loader/>
  );
}
    return (<>
    <CommonBreadcrumb items={items}/>
       <Container className='pt-5'>
         <Row className='align-items-center'>
            <Col lg={4}>
                <Image src={productData?.data?.product_image} className='img-fluid w-100' />
            </Col>
            <Col lg={6}>
             {productData?.data?.brand &&<span>  {productData?.data?.brand}</span> }
                     <h3 className='text-capitalize mb-3'>
                    {productData?.data?.product_name}
                </h3>
               <div className='d-flex gap-2 align-items-center mb-3'>
                <h5 className='m-0'>£ {productData?.data?.product_price}</h5>
                  {( productData?.data?.discount !==  false) && <span className='bg-danger px-3 py-1 text-white d-inline-block rounded'>  {productData?.data?.discount_percentage}%</span> }
               </div>
                <p>
                    {productData?.data?.product_description}
                </p>
              
            </Col>


        </Row>
       </Container>
    </>
    )
}

export default ProductView